import {
  Badge,
  Container,
  Group,
  Paper,
  SimpleGrid,
  Stack,
  Text,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useEffect, useState } from "react";
import { findAllAnalysisRunResults } from "../monitorsApi";
import { useBrandContext } from "../brandContext";
import LlmProviderLogo from "../../LlmProviders/LlmProviderLogo";
import AnswerMarkdown from "../../_Shared/AnswerMarkdown";
import { IconSpeakerphone } from "@tabler/icons-react";
import BrandBreadcrumbs from "../BrandBreadcrumbs";
import QueryTypeBadge from "../../_Shared/QueryTypeBadge";

function ResultOverview({ analysis }) {
  return (
    <SimpleGrid my="xs" cols={3}>
      <Paper ta="center" withBorder shadow="xs" p="xs">
        Sentiment
        <br /> {analysis.sentimentLabel} {analysis.sentimentScore}
      </Paper>

      <Paper ta="center" withBorder shadow="xs" p="xs">
        Mention rank
        <br />
        {analysis.mentionRank === 0 ? (
          <Text c="red">N/A</Text>
        ) : (
          <Text>{analysis.mentionRank}</Text>
        )}
      </Paper>

      <Paper ta="center" withBorder shadow="xs" p="xs">
        <Group m={0} justify="center">
          <IconSpeakerphone /> Share of Voice
        </Group>
        {analysis.shareOfVoice === 0 ? (
          <Text c="red">N/A</Text>
        ) : (
          <Text>{(analysis.shareOfVoice * 100).toFixed(0)} %</Text>
        )}
      </Paper>
    </SimpleGrid>
  );
}

export default function AllAnalysisPrompts({ params }) {
  const [invocations, setInvocations] = useState([]);
  const { selectBrandById } = useBrandContext();

  useEffect(() => {
    if (params.brandId) selectBrandById(params.brandId);
  }, [params.brandId, selectBrandById]);

  useEffect(() => {
    findAllAnalysisRunResults(params.brandId, params.monitorRunId)
      .then(setInvocations)
      .catch((error) => {
        console.error("Error fetching analysis runs:", error);
        notifications.show({
          title: "Error",
          message: "Failed to fetch analysis runs",
          color: "red",
        });
      });
  }, [params.brandId]);

  return (
    <Container>
      {/* <BrandBreadcrumbs brandId={params.brandId} /> */}

      {invocations.map((run) => (
        <Paper withBorder key={run.id} shadow="xs" p="md" mb="md">
          <Group gap="lg">
            <LlmProviderLogo llmProvider={run.llmIdPath[0]} size={32} />
            <Stack style={{ flex: 1 }} gap={2}>
              <Group
                wrap="nowrap"
                style={{ flex: 1 }}
                justify="space-between"
                align="center"
              >
                <Text fw={500}>{run.prompt}</Text>
                <Group justify="flex-end" gap="xs">
                  <Text fz="sm" c="dimmed">
                    {new Date(run.createdAt).toLocaleString()}
                  </Text>
                </Group>
              </Group>
              <Group gap="xs">
                <QueryTypeBadge size="xs" queryType={run.analysis?.queryType} />
                <Badge variant="light" size="xs">
                  {run.analysis?.industry}
                </Badge>
                <Badge variant="light" size="xs">
                  {run.analysis?.aspect}
                </Badge>
              </Group>
            </Stack>
          </Group>
          {/* <Code block>{JSON.stringify(run.analysis, null, 2)}</Code> */}
          <ResultOverview analysis={run.analysis} />
          <AnswerMarkdown
            text={run.llmResponse}
            highlightTerms={run.analysis?.brandMentions}
          />
        </Paper>
      ))}
    </Container>
  );
}
